import { Component, OnInit } from '@angular/core';

import { VehicleregistrationService } from '../../services/vehicleregistration.service';
import { IVehicleRegistration } from '../../models/vehicleregistration';
import { Router } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';

import { CreatecarComponent } from '../createcar/createcar.component';
import { EditcarComponent } from '../editcar/editcar.component';

import { IProduct } from 'src/app/models/contract';
import { CurrentparkingService } from '../../services/currentparking.service';

@Component({
  selector: 'app-mycars',
  templateUrl: './mycars.component.html',
  styleUrls: ['./mycars.component.css']
})
export class MycarsComponent implements OnInit {
cookie = '';
mineBiler: IVehicleRegistration[] = [];
products?: IProduct[] = [];
anyContractParkings = false;

  constructor(
    private vehicleService: VehicleregistrationService,
    private currentParkingService: CurrentparkingService,
    private router: Router,
    private dialog: MatDialog) {

    dialog.afterAllClosed.subscribe(() => {
      this.getCars();
    });
   }

  ngOnInit() {
    if (localStorage.getItem('newAccount')) {
      this.cookie = JSON.stringify(localStorage.getItem('newAccount'));
    }

    this.currentParkingService.currentParkings().subscribe(parking => {
      this.anyContractParkings = parking.some(e => e.data.parkingType === 4);
    });
    
  }

  getCars() {
    this.vehicleService.registrations().subscribe(result => {
      this.mineBiler = result;
    });
  }

  createCar() {
    this.dialog.open(CreatecarComponent, {
    });
  }

  editCar(key: string) {
    this.dialog.open(EditcarComponent, {
      data: { key: key }
    });
  }

  next() {
    localStorage.removeItem('newAccount');
    this.router.navigate(['']);
  }
}
